import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { formatMoney } from '../utils/helpers/helpers';
import {
  getIncomeStatic,
  getIncomeStaticDetail,
} from '../features/dashboard/actions';
function useDashboardDetail(props) {
  const [sortBy, setSortBy] = useState(7);
  const [listIncomeStaticDetails, setListIncomeStaticDetails] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [incomeStatic, setIncomeStatic] = useState({});
  const [params, setParams] = useState({
    pageNum: 0,
    pageSize: 10,
  });
  const columns = [
    {
      title: 'Ngày',
      dataIndex: 'bookingTime',
      key: 'bookingTime',
      render: (bookingTime) => {
        return bookingTime.split(' ')[1].replaceAll('-', '/');
      },
    },
    {
      title: 'Sản phẩm',
      dataIndex: 'module',
      key: 'module',
    },
    {
      title: 'Giá trị đơn hàng',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      render: (totalAmount) => <>{`${formatMoney(totalAmount)} VNĐ`}</>,
    },
    {
      title: 'Trạng thái đơn hàng',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Hoa hồng',
      dataIndex: 'commission',
      key: 'commission',
      render: (commission) => <>{`${formatMoney(commission)} VNĐ`}</>,
    },
    {
      title: 'Thời gian hoàn tất',
      dataIndex: 'completedTime',
      key: 'completedTime',
    },
  ];
  const handleSortDate = (type) => {
    if (type !== sortBy) {
      setSortBy(type);
      handleFetchIncomeStatic(type, 0);
    }
  };

  const handleFetchIncomeStatic = async (type = 7, pageNum = 0) => {
    const paramsStatic = {
      to: moment().format('YYYY-MM-DD 23:59:59'),
      from: moment().subtract(type, 'd').format('YYYY-MM-DD 00:00:00'),
    };
    fetIncomeStatic(paramsStatic);
    const paramsStaticDetail = {
      ...paramsStatic,
      pageNum: pageNum !== undefined ? pageNum : params.pageNum,
      pageSize: params.pageSize,
    };
    const result = await fetIncomeStaticDetail(paramsStaticDetail);
    if (result) {
      setParams({ ...params, pageNum: paramsStaticDetail.pageNum });
    }
  };

  useEffect(() => {
    handleFetchIncomeStatic();
    // eslint-disable-next-line
  }, []);

  const fetIncomeStatic = async (params = {}) => {
    try {
      const { data } = await getIncomeStatic(params);
      if (data.code === 200) {
        setIncomeStatic(data.data);
      }
    } catch (err) {}
  };

  const fetIncomeStaticDetail = async (params = {}) => {
    try {
      const { data } = await getIncomeStaticDetail(params);
      if (data.code === 200) {
        setListIncomeStaticDetails(data.data.items);
        setTotalElements(data.data.total);
        return true;
      }
    } catch (err) {}
  };

  const onChangePagination = async (page, size) => {
    setParams({
      pageNum: page - 1,
      pageSize: size,
    });
    const paramsStaticDetail = {
      to: moment().format('YYYY-MM-DD 23:59:59'),
      from: moment().subtract(sortBy, 'd').format('YYYY-MM-DD 00:00:00'),
      pageNum: page - 1,
      pageSize: size,
    };
    await fetIncomeStaticDetail(paramsStaticDetail);
  };
  return {
    onChangePagination,
    handleSortDate,
    sortBy,
    listIncomeStaticDetails,
    totalElements,
    incomeStatic,
    params,
    columns,
  };
}

export default useDashboardDetail;
